import React from "react";
import { withRouter } from "react-router-dom";
import AllAppBtn from "./headerComponents/AllAppBtn";
import RecentVisit from "./headerComponents/recentVisit";
// import GroupSelection from "./headerComponents/GroupSelection";
import Breadcrumb from "./headerComponents/Breadcrumb/index";
import { throttle, GetQuery, isInsideTab } from "Pub/js/utils";
import AllBench from "./headerComponents/AllBench";
import { getRelateidObj } from "../pages/NewHome/utilService";

const showRecentVisit = false;
/**
 * workbench 工作桌面头部左侧集合
 */
class HeaderLeft extends React.Component {
    constructor(props) {
        super(props);
        const urlRequestObj = GetQuery(props.location.search);
        this.state = {
            groupSelectShow: false, //是否显示集团切换
            relateidObj: getRelateidObj(
                urlRequestObj.pk_responsibility,
                urlRequestObj.is_group,
                urlRequestObj.workbenchid
            )
        };
    }
    //点击显示集团切换
    handleGroupSwitchClick = throttle(() => {
        this.setState({ groupSelectShow: !this.state.groupSelectShow });
    }, 300)

    render() {
        let { onBreadCrumbClick, ispreview, navConfig } = this.props;
        const { showCrumb } = navConfig;
        const { groupSelectShow, relateidObj } = this.state;
        return (
            <React.Fragment>
                <AllAppBtn {...this.props} />
                {showRecentVisit && <RecentVisit className='show-right-line' {...this.props} />}
                {
                    // && typeof (ispreview) === 'boolean' 
                    showCrumb && !ispreview ?
                        <div className="compose-container">
                            {/* <GroupSelection
                                    showIcon={true}
                                    groupSelectShow={groupSelectShow}
                                    onGroupSwitchClick={this.handleGroupSwitchClick}
                                /> */}

                            {/* {!groupSelectShow && <span className="block-span margin-right-14" />} */}
                            {!groupSelectShow && <Breadcrumb onBreadCrumbClick={onBreadCrumbClick} />}
                        </div>
                        : (
                            // <GroupSelection showIcon={false} groupSelectShow={true} />
                            <AllBench relateidObj={relateidObj} ispreview={ispreview} />
                        )
                }
            </React.Fragment>
        );
    }
}
export default withRouter(HeaderLeft);
